/* Package JSON Import will be here */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
/* Package JSON Import will be here */

/* Project Import will be here */
import SupervisorOverrideReasonComponent from './supervisorOverrideReason.component';
import { ApiUrls } from '../../services/api';
import Api from '../../services/api/serviceCall';
import { Constants } from '../../config/appConstants';
import { MessageBox } from '../sharedComponent/messageBox';
import { bindActionCreators } from 'redux';
import * as actions from '../../actions/login.Action';
/* Project Import will be here */

class SupervisorOverrideReason extends Component {
    constructor(props) {
        super(props);
        this.state = {
            supervisorOverrideReasonSearchText: "",
            selectedIdForDelete: "",
            supervisorOverrideReason: [],
            isOpenModel: false,
            isSetButtonDisabled: false,
            isDeleteConfirm: false,
            isEditSupervisorOverrideReason: false,
            selectedSupervisorOverrideReason: {},
            pagination: {
                activePage: 1,
                totalCount: 0,
                skip: Constants.DEFAULT_SKIP,
                take: Constants.DEFAULT_TAKE
            },
        };
    }

    componentDidMount() {
        this.getSupervisorOverrideReasonList();
    }

    getSupervisorOverrideReason(supervisorOverrideReasonId) {
        let { selectedSupervisorOverrideReason } = this.state;
        const url = `${ApiUrls.Routes.SPVRORERN_C}${ApiUrls.Routes.GT_SPVR_ORE_RN_M}?supervisorOverrideReasonId=${supervisorOverrideReasonId}`;
        Api.Get(url, this).then((responseData) => {
            if (responseData) {
                if (responseData.success) {
                    responseData.data.supervisorOverrideReason.forEach((a) => {
                        selectedSupervisorOverrideReason.displayText = a.displayText;
                        selectedSupervisorOverrideReason.supervisorOverrideReasonId = a.id;
                        selectedSupervisorOverrideReason.isActive = a.isActive;
                        selectedSupervisorOverrideReason.isDeleted = a.isDeleted;
                    });
                    this.setState({
                        selectedSupervisorOverrideReason, isEditSupervisorOverrideReason: true
                    });
                }
            }
        });
    }

    getSupervisorOverrideReasonList() {
        const { supervisorOverrideReasonSearchText, pagination } = this.state;
        let searchArray = [];
        if (supervisorOverrideReasonSearchText) {
            const searchObj = {
                FieldName: Constants.SUPERVISOR_OVERRIDE_REASON_NAME_SEARCH,
                Value: supervisorOverrideReasonSearchText
            };
            searchArray.push(searchObj);
        };
        const requestData = {
            SearchText: searchArray,
            Skip: pagination.skip,
            Take: pagination.take
        }
        const url = `${ApiUrls.Routes.SPVRORERN_C}${ApiUrls.Routes.GT_SPVR_ORE_RN_LT_M}`;
        Api.Post(url, requestData, this).then((responseData) => {
            if (responseData) {
                if (responseData.success) {
                    responseData.data.sort((a, b) => {
                        const nameA = a.displayText.toUpperCase();
                        const nameB = b.displayText.toUpperCase();
                        if (nameA < nameB) return -1;
                        if (nameA > nameB) return 1;
                        return 0;
                    });
                    pagination.totalCount = Math.ceil(responseData.totalCount / Constants.DEFAULT_TAKE);
                    this.setState({ supervisorOverrideReason: responseData.data, pagination });
                }
                else {
                    this.setState({ supervisorOverrideReason: [] });
                }
            }
        });
    }

    onPageChange = (e, { activePage }) => {
        const { pagination } = this.state;
        pagination.skip = ((activePage - 1) * Constants.DEFAULT_TAKE) + 1;
        pagination.take = ((activePage - 1) * Constants.DEFAULT_TAKE) + Constants.DEFAULT_TAKE;
        pagination.activePage = activePage;
        this.setState({ pagination }, () => { this.getSupervisorOverrideReasonList() });
    }

    onSupervisorOverrideReasonSearch = event => {
        this.setState({ supervisorOverrideReasonSearchText: event.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 } }, () => {
            this.getSupervisorOverrideReasonList();
        });
    }

    handleSupervisorOverrideReasonChange = (e, { value }) => {
        const { selectedSupervisorOverrideReason } = this.state;
        selectedSupervisorOverrideReason.displayText = value;
        this.setState({ selectedSupervisorOverrideReason });
    }

    onOpenModel = selectedSupervisorOverrideReason => {
        if (selectedSupervisorOverrideReason.supervisorOverrideReasonId) {
            this.getSupervisorOverrideReason(selectedSupervisorOverrideReason.supervisorOverrideReasonId);
        }
        this.setState({
            isOpenModel: true,
            selectedSupervisorOverrideReason: {},
            isSetButtonDisabled: false
        });
    }

    onCloseModel = () => {
        this.setState({ isOpenModel: false, isEditSupervisorOverrideReason: false, selectedSupervisorOverrideReason: {} }, () => this.getSupervisorOverrideReasonList());
    }

    onSaveSupervisorOverrideReason(supervisorOverrideReasonId) {
        const { selectedSupervisorOverrideReason } = this.state;
        this.setState({ isSetButtonDisabled: true }, () => {
            if (!selectedSupervisorOverrideReason.displayText || !selectedSupervisorOverrideReason.displayText.trim()) {
                MessageBox(Constants.PLEASE_ENTER_SUPERVISOR_OVERRIDE_REASON, Constants.ERROR);
                this.setState({ isSetButtonDisabled: false });
                return;
            }
            const requestData = {
                Id: supervisorOverrideReasonId,
                DisplayText: selectedSupervisorOverrideReason.displayText.trim(),
                IsActive: selectedSupervisorOverrideReason.isActive,
            }
            const url = `${ApiUrls.Routes.SPVRORERN_C}${ApiUrls.Routes.SVE_SPVR_ORE_RN_M}`;
            Api.Post(url, requestData, this).then((responseData) => {
                MessageBox(responseData.message, responseData.success ? Constants.SUCCESS : Constants.ERROR);
                this.setState({ isSetButtonDisabled: false });
                if (responseData.success) {
                    this.onCloseModel();
                }
            });
        });
    }

    onDeleteSupervisorOverrideReason = (selectedSupervisorOverrideReason) => {
        this.setState({ isDeleteConfirm: true, selectedIdForDelete: selectedSupervisorOverrideReason.supervisorOverrideReasonId });
    }

    onCancelDelete = () => {
        this.setState({ isDeleteConfirm: false, selectedSupervisorOverrideReason: {} });
    }

    onConfirmDelete = () => {
        const { selectedIdForDelete } = this.state;
        const url = `${ApiUrls.Routes.SPVRORERN_C}${ApiUrls.Routes.DLT_SPVR_ORE_RN_M}?supervisorOverrideReasonId=${selectedIdForDelete}`;
        Api.Get(url, this).then((responseData) => {
            if (responseData.success) {
                this.setState({ isDeleteConfirm: false, selectedSupervisorOverrideReason: {} }, () => {
                    const page = Math.ceil((this.state.pagination.totalRecordCount - 1) / Constants.DEFAULT_TAKE);
                    this.onPageChange(null, { activePage: this.state.pagination.activePage > page ? page : this.state.pagination.activePage });
                });
            }
            MessageBox(responseData.message, responseData.success ? Constants.SUCCESS : Constants.ERROR);
        });
    }

    render() {
        const { supervisorOverrideReason, isEditSupervisorOverrideReason, isSetButtonDisabled, selectedSupervisorOverrideReason, isOpenModel, pagination, isDeleteConfirm } = this.state;
        return (
            <Fragment>
                <SupervisorOverrideReasonComponent
                    {...{
                        supervisorOverride: {
                            pagination,
                            isOpenModel,
                            isDeleteConfirm,
                            isSetButtonDisabled,
                            isEditSupervisorOverrideReason,
                            supervisorOverrideReason,
                            selectedSupervisorOverrideReason,
                        }
                    }}
                    onOpenModel={this.onOpenModel.bind(this)}
                    onCloseModel={this.onCloseModel.bind(this)}
                    onPageChange={this.onPageChange.bind(this)}
                    onCancelDelete={this.onCancelDelete.bind(this)}
                    onConfirmDelete={this.onConfirmDelete.bind(this)}

                    onSaveSupervisorOverrideReason={this.onSaveSupervisorOverrideReason.bind(this)}
                    onSupervisorOverrideReasonSearch={this.onSupervisorOverrideReasonSearch.bind(this)}
                    handleSupervisorOverrideReasonChange={this.handleSupervisorOverrideReasonChange.bind(this)}
                    onDeleteSupervisorOverrideReason={this.onDeleteSupervisorOverrideReason.bind(this)}
                />
            </Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.loginReducer.user
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        Object.assign({},
            actions),
        dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SupervisorOverrideReason));
SupervisorOverrideReason.displayName = 'SupervisorOverrideReason';